<template>
  <div style="width:100%;">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>
    <div style="padding-top: 50px;" class="mater">
      <b-table sticky-header sticky-header="calc(100vh - 50px)" class="bgc-dark" head-variant="dark" responsive bordered
               :items="items" :fields="fields" foot-clone>
        <template v-slot:head()="scope">
          <div class="text-nowrap" :style="{textAlign:'center'}">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          {{ data.index + 1 }}
        </template>
        <template v-slot:cell(companyAmount)="data">
          {{ Number(data.item.companyAmount).toFixed(2)}}
        </template>
        <template v-slot:cell(personAmount)="data">
          {{ Number(data.item.personAmount).toFixed(2)}}
        </template>
        <template v-slot:cell(pensionAmount)="data">
          {{ Number(data.item.pensionAmount).toFixed(2)}}
        </template>
        <template v-slot:cell(medicAmount)="data">
          {{ Number(data.item.medicAmount).toFixed(2)}}
        </template>
        <template v-slot:cell(maternityAmount)="data">
          {{ Number(data.item.maternityAmount).toFixed(2)}}
        </template>
        <template v-slot:cell(injuryAmount)="data">
          {{ Number(data.item.injuryAmount).toFixed(2)}}
        </template>
        <template v-slot:cell(loseAmount)="data">
          {{ Number(data.item.loseAmount).toFixed(2)}}
        </template>
        <template v-slot:cell(payableAmount)="data">
          {{ Number(data.item.payableAmount).toFixed(2)}}
        </template>
        <template v-slot:cell(spAmount)="data">
          {{ Number(data.item.spAmount).toFixed(2)}}
        </template>
        <template v-slot:cell(othersAmount)="data">
          {{ Number(data.item.othersAmount).toFixed(2)}}
        </template>
        <template v-slot:cell(siAmount)="data">
          {{ Number(data.item.siAmount).toFixed(2)}}
        </template>
        <template v-slot:cell(pfAmount)="data">
          {{ Number(data.item.pfAmount).toFixed(2)}}
        </template>
        <template v-slot:cell(iitAmount)="data">
          {{ Number(data.item.iitAmount).toFixed(2)}}
        </template>
        <template v-slot:cell(requestAmount)="data">
          {{ Number(data.item.requestAmount).toFixed(2)}}
        </template>
        <template v-slot:cell(budgetBalance)="data">
          {{ ((data.item.budgetAmount||0) - (data.item.budgetUsedAmount||0) - (data.item.budgetApportionAmount || 0)).toFixed(2)}}
        </template>
        <template v-slot:cell(budgetAnnual)="data">
          {{data.item.budgetControl!='3'  ? data.item.budgetAnnual : '-' }}
        </template>
        <template v-slot:cell(budgetSubjectCode)="data">
          {{data.item.budgetControl!='3'  ? data.item.budgetSubjectCode : '-' }}
        </template>
        <template v-slot:cell(budgetSubjectFullName)="data">
          {{data.item.budgetControl!='3'  ? data.item.budgetSubjectFullName : '-' }}
        </template>
        <template v-slot:cell(budgetAmount)="data">
          {{data.item.budgetControl!='3'  ? Number(data.item.budgetAmount).toFixed(2) : '-' }}
        </template>
        <template v-slot:cell(budgetUsedAmount)="data">
          {{data.item.budgetControl!='3'  ? Number(data.item.budgetUsedAmount).toFixed(2) : '-' }}
        </template>
        <template v-slot:table-colgroup="scope">
          <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="{ width:  field.key === 'index' ?'50px':(field.key === 'businessTypeName' || field.key === 'budgetProjectName' || field.key === 'budgetUsedAmount'||field.key === 'budgetApportionAmount'||field.key === 'companyAmount'||field.key === 'personAmount'||field.key === 'iitAmount'||field.key === 'pfAmount'||field.key === 'siAmount'||field.key === 'accountSubjectFullName')? '140px': field.key === 'payeeBankAccount' ? '160px' : '100px',left: '80px'}"
          />
        </template>
        <template v-slot:foot()="scope">
          <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
        </template>
        <template v-slot:foot(index)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
        </template>
        <template v-slot:foot(companyAmount)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'companyAmount')}}</div>
        </template>
        <template v-slot:foot(personAmount)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'personAmount')}}</div>
        </template>
        <template v-slot:foot(pensionAmount)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'pensionAmount')}}</div>
        </template>
        <template v-slot:foot(medicAmount)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'medicAmount')}}</div>
        </template>
        <template v-slot:foot(maternityAmount)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'maternityAmount')}}</div>
        </template>
        <template v-slot:foot(injuryAmount)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'injuryAmount')}}</div>
        </template>
        <template v-slot:foot(loseAmount)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'loseAmount')}}</div>
        </template>
        <template v-slot:foot(payableAmount)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'payableAmount')}}</div>
        </template>
        <template v-slot:foot(spAmount)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'spAmount')}}</div>
        </template>
        <template v-slot:foot(othersAmount)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'othersAmount')}}</div>
        </template>
        <template v-slot:foot(siAmount)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'siAmount')}}</div>
        </template>
        <template v-slot:foot(pfAmount)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'pfAmount')}}</div>
        </template>
        <template v-slot:foot(iitAmount)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'iitAmount')}}</div>
        </template>

        <template v-slot:foot(requestAmount)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'requestAmount')}}</div>
        </template>

      </b-table>
    </div>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import {BTable} from 'bootstrap-vue'


export default {
  data() {
    return {
      fields: [],
      items: [],
      layoutHeight: '0px',
      time: 0
    }
  },
  mounted() {
  },
  created() {
    this.$nextTick(() => {
      this.layoutHeight = document.documentElement.clientHeight - 50 + 'px';
      let query = this.$route.query;
      this.fields = query.fieldsList
      this.items = query.dataList
    });
  },
  methods: {
    init() {
    },
    joint(data) {
      this.items.forEach(i => {
        i.materialData = {}
        data.forEach(key => {
          i.materialData[key] = i[key]
        })
      })
    },
    goBack() {
      this.$router.go(-1);
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
  }
}
</script>

<style>
.mater tr th:nth-child(2),.mater tr td:nth-child(2) {
  left: 30px !important;
}
</style>
